import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';
import { ElementsModule } from '../common/elements/elements.module';
import { CrmRoutingModule } from './crm-routing.module';
import { CrmComponent } from './crm.component';
import { CrmDetailsComponent } from './details/crm-details.component';
import { CrmDateFormatSelectComponent } from './crm-components/crm-date-format-select.component';
import { CrmPrintMenuComponent } from './crm-components/crm-print-menu.component';
import { CrmService } from './crm.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ElementsModule,
    CrmRoutingModule
  ],
  declarations: [
    CrmComponent,
    CrmDetailsComponent,
    CrmDateFormatSelectComponent,
    CrmPrintMenuComponent
  ],
  providers: [CrmService]
})
export class CrmModule { }
